import type {Ticket, TicketStatus} from '../types/ticket';

export type GroupedTickets = Record<TicketStatus, Ticket[]>;

export function groupTicketsByStatus(tickets: readonly Ticket[]): GroupedTickets {
	const grouped: GroupedTickets = {
		open: [],
		in_progress: [],
		waiting_on_customer: [],
		resolved: [],
		closed: [],
	};
	for (const t of tickets) {
		grouped[t.status].push(t);
	}
	return grouped;
}
